module.exports = __webpack_public_path__ + "static/media/checked.3c0147e4.svg";